// src/components/error/GlobalErrorBoundary.tsx
import React from "react";
import ErrorScreen from "../screens/ErrorScreen";

interface Props {
    children: React.ReactNode;
}

interface State {
    hasError: boolean;
    error?: Error;
}

export class GlobalErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        // Log error to your logging service
        console.error("Uncaught error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <ErrorScreen error={this.state.error} />;
        }

        return this.props.children;
    }
}

export default GlobalErrorBoundary;
